import { createAction } from 'redux-actions';

export const getTransactionActivitiesSearchAction = createAction(
  'GET_TRANSACTION_ACTIVITIES_SEARCH',
);
export const resetTransactionActivitiesSearchAction = createAction(
  'RESET_TRANSACTION_ACTIVITIES_SEARCH',
);
